
import React from 'react'
import cardImg from "../assets/images/cardImg.svg";
import persTestImgMob from "../assets/images/persTestImgMob.svg";
import persTestImg from "../assets/images/persTestImg.svg";
import vdolywo from "../assets/images/vdolywo.svg";
// import { RiRadioFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';


export default function Quizthankyou() {
  const navigate = useNavigate();
  return (

    <div className="text-center mt-4 thnkyou">
      <h3>Dear Hari Prasad Chauhan</h3>
      <h1>Thank You</h1>
    </div>

  )
}
